/** @type {import('./check-ignore').IgnoreDefinition[]} */
const ignoreList = [
  {
    route: {
      includes: '/portal/options'
    },
    message: {
      includes: 'ResizeObserver loop completed with undelivered notifications'
    }
  },
  {
    route: {
      includes: '/portal/explore-other-products',
    },
    message: {
      includes: 'ResizeObserver loop completed with undelivered notifications'
    }
  },
]
export default ignoreList
